import { Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { Fragment, useState } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import EditRowMoverAdd from './components/EditRowMoverAdd';
import ReadOnlyRowMoverAdd from './components/ReadOnlyRowMoverAdd';
import { moverProducto } from '../../../actions/almacen';

const AlmacenTablaMover = ({ currentUser, dispatch, disponibilidadProducto, setDisponibilidadProducto }) => {

    const [editRowId, setEditRowId] = useState(null);

    const handleUpdate = (newRow) => {
        const newDiponibilidadProducto = disponibilidadProducto.map((dp) => (
            dp.lot == newRow.lot ? newRow : dp
        ))
        setDisponibilidadProducto(newDiponibilidadProducto);
        setEditRowId(0);
    }

    const handleSave = async (row) => {
        //console.log(row);
        try {
            const result = await moverProducto('DISPONIBILIDAD', row, currentUser, dispatch);
            //console.log({result});
            setDisponibilidadProducto([]);
        } catch (error) {

        }



    }


    return (
        <Fragment>
            <Stack direction='column' bgcolor='white' height='100%' sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Box style={{ height: 500, maxWidth: '1000px', backgroundColor: 'white' }}>
                    <Typography variant="h5" component="h5" p={2} align='center'>
                        Detalle Mover
                    </Typography>
                    <Box mt={6}>
                        <TableContainer>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>Lote</TableCell>
                                        <TableCell align='left'>Costo</TableCell>
                                        <TableCell align='left'>Precio</TableCell>
                                        <TableCell align='left'>Vencimiento</TableCell>
                                        <TableCell align='left'>Cantidad Disp</TableCell>
                                        <TableCell align='left'>Cantidad a Mover</TableCell>
                                        <TableCell align='left'>Controles</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {disponibilidadProducto.map((dispProd) => (
                                        editRowId === dispProd.lot ?
                                            <EditRowMoverAdd
                                                row={dispProd}
                                                handleUpdate={handleUpdate}
                                                setEditRowId={setEditRowId}
                                            />
                                            : <ReadOnlyRowMoverAdd
                                                row={dispProd}
                                                setDisponibilidadProducto={setDisponibilidadProducto}
                                                setEditRowId={setEditRowId}
                                                handleSave={handleSave}
                                            />

                                    ))}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>





                </Box>

                {false &&
                    <Box width='100%' sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', border: '1px solid lightgray', borderRadius: 1 }}>
                        <Box width={'40%'} m={2} maxWidth={'200px'}>
                            <Button variant='outlined' fullWidth={true} startIcon={<SaveIcon />}>Guardar Todo</Button>
                        </Box>
                    </Box>
                }

            </Stack>
        </Fragment>
    )
}

export default AlmacenTablaMover